<template>
  <b-container id="contact" class="pb-3" fluid>
    <h3>
      <b-row no-gutters align-v="center">
        <b-col cols="1">
          <font-awesome-icon icon="pen-fancy"/>
        </b-col>
        <b-col class="pt-1" cols="8">
          <span>
            Contact Me
          </span>
        </b-col>
      </b-row>
    </h3>
    <div>
      <b-form @submit="onSubmit" @reset="onReset" v-if="show" class="py-3 ml-4 mb-4">
        <b-form-group
          id="input-group-1"
          label="Email address:"
          label-for="input-1"
          description="We'll never share your email with anyone else."
        >
          <b-form-input
            id="input-1"
            v-model="form.email"
            type="email"
            required
            placeholder="Enter email"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label="Your Name:" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="form.name"
            required
            placeholder="Enter name"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-3" label="Message:" label-for="input-3">
          <b-form-textarea
            id="input-3"
            v-model="form.message"
            placeholder="Please write your message or inquiry."
            rows="3"
            max-rows="7"
            no-auto-shrink
            required
          ></b-form-textarea>
        </b-form-group>
        <p class="pl-2 text-muted">{{ outText }}</p>

        <b-button class="mx-4" type="submit" variant="primary" v-if="!loading">Submit</b-button>
        <b-button class="mx-4" variant="light" v-else>
          <b-spinner small type="grow" variant="dark"></b-spinner>
        </b-button>
        <b-button class="mx-4" type="reset" variant="danger">Reset</b-button>
      </b-form>
    </div>
  </b-container>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      loading: false,
      form: {
        email: '',
        name: '',
        message: ''
      },
      show: true,
      outText: ''
    }
  },
  methods: {
    onSubmit (evt) {
      this.loading = true
      this.$nextTick(() => {
        evt.preventDefault()
        axios.post('https://us-central1-strong-jetty-266921.cloudfunctions.net/submit', this.form)
          .then(() => {
            this.onReset(evt)
            this.outText = 'Information Successfully Submitted'
            this.loading = false
          })
          .catch((error) => {
            alert(`Error: Data not submitted`)
            this.outText = 'Error Sending Request'
            error = null
            this.loading = false
          })
      })
      this.show = true
    },

    onReset (evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.email = ''
      this.form.name = ''
      this.form.message = ''
      this.outText = ''
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    }
  }
}
</script>
